import React from "react";

const ArrowLeft = ({ size = 4, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 200 200"
      width={size * 4}
      height={size * 4}
    >
      <g clipPath="url(#_clipPath_RVWNxj0HHUbY6s2nEozKl5iY6qExVC8l)">
        <path
          d=" M 55.063 26.691 C 47.114 34.927 47.291 48.229 55.457 56.249 L 100.001 100.001 L 56.64 144.926 C 48.691 153.161 48.868 166.463 57.034 174.484 C 65.2 182.505 78.387 182.329 86.336 174.093 L 144.149 114.194 C 152.098 105.958 151.921 92.656 143.755 84.636 L 84.363 26.301 C 76.197 18.279 63.012 18.455 55.063 26.691 Z "
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ArrowLeft;
